import {type IOwayoDataModel} from "./model";
import {type ISelObInfoProvider, type ISnapshotTaker} from "./owayoJSViewerWithSelObs";
import {EventListener, EventVerteiler} from "../global/eventVerteiler";
import {GLOBALEVENTNAMES} from "../global/GlobalEventnames";
import {ShareDraftController} from "./controllerModules/ShareDraftController";
import {AnfragenController, HelpAnfrageParameters} from "./controllerModules/anfragenController";
import {Entwurfpersistance} from "./controllerModules/entwurfpersistance";
import {OpenWarenkorbController} from "./controllerModules/openWarenkorbController";
import {PreisPreviewLoader} from "../global/preisAnzeiger";
import {GoogleTracker} from "../global/googleTrackerObject";
import globalsObject, {trackPageview} from "./globalsObject";
import {SelectedFeature} from "./product";
import {sendPostRequest} from "../global/axiosFormWrapper";
import {ExemplarlisteWrapper, EXEMPLARYVIEW_PURPOSE} from "../global/ExemplarlisteWrapper";
import {looksLikeGUID, noop} from "../global/globalUtils";
import axios from "axios";
import {TextObject} from "@k/js/selectableObjects";
import {Screenblocker} from "@k/global/Screenblocker";

export interface LoadKKSaveiDFallbackParameter {
    productCategory, design, model
}

export class ActionController extends EventListener {

    private entwurfPersistance: Entwurfpersistance;
    private openWarenkorbController: OpenWarenkorbController;
    public model: IOwayoDataModel;
    private readonly tracker: GoogleTracker | null;
    private exemplarlisteOpener: ExemplarlisteWrapper;

    constructor(model: IOwayoDataModel, snapshotViewComponent: ISnapshotTaker, selObInfoProvider: ISelObInfoProvider, tracker: GoogleTracker | null, isOM = false) {
        super();
        ShareDraftController.setSnapshotTaker(snapshotViewComponent);
        this.selObInfoProvider = selObInfoProvider;
        this.model = model;
        this.tracker = tracker;
        this.entwurfPersistance = new Entwurfpersistance(model, snapshotViewComponent, selObInfoProvider, isOM);
        this.openWarenkorbController = new OpenWarenkorbController(model, selObInfoProvider, () => this.saveEntwurf( false, "", false));
        this.exemplarlisteOpener = new ExemplarlisteWrapper(
            this.model.getSprache(),
            ()=>document.getElementById("iFrameExemplarliste").classList.remove("ele-hidden"),
            ()=>document.getElementById("iFrameExemplarliste").classList.add("ele-hidden"),
            (url:string)=>(document.getElementById("iFrameExemplarliste") as HTMLIFrameElement).src = url);
        this.initEventListeners();
    }

    private initEventListeners() {
        this
            .addEventListener("prepareForLoadEvent", (data) => this.prepareForEntwurfLoading(data.saveID, data.loadExemplare))
            .addEventListener("updateWarenkorbPositionEvent", (data) => this.updateWarenkorbPosition(data.lieferpositionID, data.amount))
            .addEventListener("putDraftIntoBasketEvent", ()=>this.putEntwurfIntoBasket())
            .addEventListener("openexemplarlisteEvent", ()=>this.openExemplarListe())
    }

    public static mailSentSuccesscully() {
        globalsObject.controller.displayDialogWithSpamfolderWarning("mailSent");
        $('#help_description, #user_description').val("");
    }


    public static anfrageError = () => globalsObject.errorHandler.handleErrorTranslateMessage(
        "ajaxFail",
        "sendAnfrageEmail",
        "konf_error_sendingEmail"
    );


    // public sendexpressAnfrage = (param: ExpressanfragePostData) => {
    //     this.saveEntwurfIfNeedsSaving().then(() => AnfragenController.sendexpressAnfrage(param, this.model)).then(() => ActionController.mailSentSuccesscully()).catch(ActionController.anfrageError);
    // }
    // public duplicateEntwurfIntoWarenkorb = saveID => this.entwurfPersistance.duplicateEntwurfIntoWarenkorb(saveID);

    public createPDF = (infoEmailAdresse:string) => this.saveEntwurfIfNeedsSavingWithoutLoginWarning().then(() => ShareDraftController.createPDF(this.model, infoEmailAdresse))
    private selObInfoProvider: ISelObInfoProvider;
    public prepareForEntwurfLoading = (saveId: number, loadExemplare: boolean) => this.entwurfPersistance.prepareForEntwurfLoading(saveId, loadExemplare);
    public loadSavedEntwurf = (saveId: number, loadExemplare: boolean) => this.entwurfPersistance.loadSavedEntwurf(saveId, loadExemplare);
    public shareEntwurf = (target: string, shareByEmailInfo?) => {
        EventVerteiler.broadcastBlockRequest("prepareFB_PHP");
        ShareDraftController.shareEntwurf(target, null, this.model, shareByEmailInfo).then(response => {
            if (target === "fb") {
                this.model.entwurf.setFBPostID(response);
                trackPageview("3Dfacebookpostgesendet.htm");
                globalsObject.loopTracker.trackToolBoxEvent("share_facebook");
            } else {
                EventVerteiler.broadcast(
                    "displayDialogEvent", {dialog: "mailSentTo", messageAddition: shareByEmailInfo.email + "."});
                trackPageview("konfiaccess/3Danfreundgesendte.htm");
                globalsObject.loopTracker.trackToolBoxEvent("share_email");
            }
            EventVerteiler.broadcastBlockRequestEnded("prepareFB_PHP");
            globalsObject.resourceManager.registerLoadedResourceWithoutData("prepareFB_PHP");
        })
    }

    public deleteSavedEntwurf = (saveID: number) => this.entwurfPersistance.deleteSavedEntwurf(saveID);

    public getHelp = (parameters:HelpAnfrageParameters) => {
        this.model.entwurf.setDesignanfrage(true);
        this.saveEntwurfIfNeedsSaving().then(
            () => AnfragenController.getHelp(parameters, this.model, globalsObject.infoFromGetParameters, this.selObInfoProvider.webGLBrowserLimits).then(
                () => {
                    ActionController.mailSentSuccesscully();
                    if (parameters.typ === "Designanfrage") {
                        if (this.tracker !== null) {
                            this.tracker.trackPageview("3Ddesignanfrage.htm");
                        }
                    }
                }
            ).catch(ActionController.anfrageError)
        );
    }

    public putEntwurfIntoBasket() {
        const alreadyInBasket = this.model.entwurf.getInBasket();

        this.model.entwurf.setInBasket(true);
        const continuation = ()=>{
            if (!this.darfProduktBestelltWerden()) {
                EventVerteiler.broadcast("displayDialogEvent", {dialog: "denyOrder"});
                return;
            }
            this.exemplarlisteOpener.openExemplarlisteByPurpose(this.model.entwurf.getID(), this.model.getLieferland(), EXEMPLARYVIEW_PURPOSE.EDIT_PUT_IN_BASKET).then(()=>{
                OpenWarenkorbController.open(
                    {
                        kundenKonfi: this.model.getKundenKonfi(),
                        sprache: this.model.getSprache(),
                        land: this.model.getLieferland(),
                        entwurfID: this.model.entwurf.getID(),
                        webSportFuerProduktAuswahlInt: this.model.getWebSportFuerProduktAuswahlInt()
                    }
                );
            })
        }
        if(this.model.entwurf.needsSaving() || alreadyInBasket) {
            this.saveEntwurf(true, "warningNotLoggedInExemplare").then(()=>continuation());
        } else {
            axios.post("/konfigurator_php/actionmodul/entwurfPersistance/setInBasketFlag.php?saveid="+this.model.entwurf.getID()).then(()=>continuation());
        }

    }

    public saveEntwurfIfNeedsSavingWithoutLoginWarning() {
        return this.saveEntwurfIfNeedsSaving(false);
    }

    public saveEntwurfIfNeedsSaving(displayWarning = true, displayWarningText = "warningNotLoggedIn"): Promise<void> {
        return new Promise<void>(resolve => {
            if (!this.model.entwurf.needsSaving()) {
                resolve();
                return;
            }
            this.saveEntwurf(displayWarning, displayWarningText).then(()=>resolve());
        })

    }

    public saveEntwurf = (displayWarning = true, displayWarningText = "warningNotLoggedIn", visible = true) => {
        return this.entwurfPersistance.saveEntwurf(displayWarning,displayWarningText,visible);
    }
    public openWarenkorb = () => this.openWarenkorbController.execute();

    loadKundenKonfiVorbelegungsSaveIDByDBSchnittAndSelectedFeatures(dvSchnitt:string, selectedFeatures:SelectedFeature[], design) {
        return sendPostRequest("/konfigurator_php/auswahlmodul/getKK_SaveIDByDVSchnitt.php", {dvSchnitt, selectedFeatures, design})
    }

    loadKundenKonfiVorbelegungsEntwurf(designFromGetParameters, fallbackToLoad:LoadKKSaveiDFallbackParameter, tryNumber = 0) {
        $.ajax({
            url: "/konfigurator_php/auswahlmodul/getKK_SaveId.php?model=" + this.model.getCurrentOwayoProduct().model + "&design=" + globalsObject.infoFromGetParameters.productInfo.design,
            dataType: "json",
            type: "GET"
        })
            .done((response) => this.processLoadedKKVorbelegungsEntwurf(response, fallbackToLoad, tryNumber))
            .fail(() => globalsObject.errorHandler.handleError("fatal", "loadKundenKonfiVorbelegungsEntwurf", "could not load draft for this combination, sorry"));
    }

    private processLoadedKKVorbelegungsEntwurf(response, fallbackToLoad:LoadKKSaveiDFallbackParameter, tryNumber) {
        const $this = this;
        if (response.saveIDFound === true) {
            this.loadSavedEntwurf(response.saveID, false);
            globalsObject.resourceManager.createTask("makeEntwurfDirty")
                .when("loadedEntwurfInitialized", "done")
                .thenDo(function () {
                    $this.model.entwurf.setChangedSinceSave(false)
                })
        } else {
            globalsObject.controller.initNewEntwurf(fallbackToLoad.productCategory, fallbackToLoad.design, fallbackToLoad.model, tryNumber + 1);
        }
    }

    getPreis(amount, iso3166) {
        if (globalsObject.controller.model.getCurrentOwayoProduct() === undefined) {
            return; //kommt beim direct Login aus der Auwi vor
        }
        const preisAnzeiger = new PreisPreviewLoader(
            iso3166,
            globalsObject.controller.model.getGlobalRabattcode(),
            globalsObject.controller.model.entwurf.getLogoObjects(),
            globalsObject.controller.model.entwurf.getTextObjects() as TextObject[]
        );
        preisAnzeiger.setProductInfoFromOwayoProduct(globalsObject.controller.model.getCurrentOwayoProduct(), globalsObject.controller.model.entwurf.getHerstellerlogosDeleted());
        // preisAnzeiger.getPreis(amount, "updatePreisPreviewEvent");
        preisAnzeiger.getPreiseUndLieferzeiten(amount, "updatePreisUndLieferzeitPreviewEvent");
    }

    updateWarenkorbPosition(saveID, amount) {
        const $this = this;

        $.ajax({
            type: "POST",
            url: "/shoppingcart/php/warenkorbUpdatePosition.php",
            data: {username: $this.model.user.getUserName(), saveID: saveID, amount: amount},
            dataType: 'json',
            success: function () {
                EventVerteiler.broadcast("activateWarenkorbViewEvent", {});
                EventVerteiler.broadcast(GLOBALEVENTNAMES.LOAD_WARENKORBDATA, {
                    sprache: $this.model.getSprache(),
                    land: $this.model.getLand()
                });
                EventVerteiler.broadcast(GLOBALEVENTNAMES.WARENKORBPOSITION_CHANGED);
            },
            error: function () {
                globalsObject.errorHandler.handleErrorTranslateMessage("ajaxFail", "getWarenkorbData", "konf_error_loadingBasket");
            }

        });
    }

    public darfProduktBestelltWerden() {
        return this.model.getCurrentOwayoProduct().warnungen.reduce(function (carry, warnung) {
            return carry && parseInt(warnung.denyOrder) === 0;
        }, true);
    }

    private openExemplarListe() {
        this.model.entwurf.setInBasket(false);
        const event = () => {
            this.exemplarlisteOpener.openExemplarlisteByPurpose(this.model.entwurf.getID(), this.model.getLieferland(), EXEMPLARYVIEW_PURPOSE.EDIT).then(noop);
        }
        if (this.model.entwurf.needsSaving() || this.model.entwurf.wasOrdered() || looksLikeGUID(this.model.entwurf.getID())) {
            globalsObject.actionController.saveEntwurf(true, "warningNotLoggedInExemplare").then(() =>event());
        } else {
            event();
        }
    }
}
